import { MessagesSquare, Zap } from "lucide-react";
import { m } from "@/paraglide/messages";
import { ContactForm } from "./contact-form";
import { DISCORD_LINKS } from "./discord-links";

function DiscordCard() {
  return (
    <div className="rounded-xl border border-[#5865F2]/30 bg-[#5865F2]/5 p-6">
      <div className="flex items-start gap-3">
        <MessagesSquare
          className="mt-0.5 h-6 w-6 shrink-0 text-[#5865F2]"
          aria-hidden="true"
        />
        <div>
          <h2 className="text-lg font-semibold text-foreground">
            {m.contact_discord_heading()}
          </h2>
          <p className="mt-1 text-sm text-muted-foreground">
            {m.contact_discord_body()}
          </p>
          <div className="mt-4 flex flex-wrap gap-2">
            <a
              href={DISCORD_LINKS.general}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 rounded-md bg-[#5865F2] px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-[#4752c4]"
            >
              <MessagesSquare className="h-4 w-4" aria-hidden="true" />
              {m.contact_discord_join()}
            </a>
            <a
              href={DISCORD_LINKS.f1Fantasy}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 rounded-md border border-border px-4 py-2 text-sm font-medium text-muted-foreground transition-colors hover:text-foreground"
            >
              #f1-fantasy
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export function ContactPage() {
  return (
    <div className="flex-1 bg-background text-foreground">
      <div className="mx-auto max-w-2xl px-5 py-12 md:py-16">
        <div className="mb-8">
          <div className="mb-4 inline-flex items-center gap-2 rounded-full border border-primary/20 bg-primary/10 px-3 py-1">
            <Zap className="h-3 w-3 text-primary" aria-hidden="true" />
            <span className="text-[11px] font-semibold uppercase tracking-wide text-primary">
              {m.footer_contact()}
            </span>
          </div>
          <h1 className="font-display text-3xl font-bold tracking-tight md:text-4xl">
            {m.contact_heading()}
          </h1>
          <p className="mt-3 text-muted-foreground">{m.contact_subtitle()}</p>
        </div>

        <div className="space-y-6">
          <ContactForm />
          <DiscordCard />
        </div>
      </div>
    </div>
  );
}
